import { Tooltip } from '@/components/ui/tooltip.tsx'
import type { PerformanceStateInfo } from '@/modules/statistics/social/types.ts'
import { SocialAccountPerformanceState } from '@/modules/statistics/social/types.ts'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  performanceState: PerformanceStateInfo
}

const performanceStateText: Record<SocialAccountPerformanceState, string> = {
  [SocialAccountPerformanceState.NA]: 'Not Enough Data',
  [SocialAccountPerformanceState.NORMAL_AVERAGE]: 'Average',
  [SocialAccountPerformanceState.ABOVE_AVERAGE]: 'Above Average',
  [SocialAccountPerformanceState.BELOW_AVERAGE]: 'Below Average',
}

export const PerformanceStateIndicator = ({ performanceState }: Props) => {
  const { state, shortPeriodAverage, longPeriodAverage } =
    performanceState ?? {}

  return (
    <Tooltip
      className="w-fit"
      content={
        state === SocialAccountPerformanceState.NA ||
        shortPeriodAverage == undefined ||
        longPeriodAverage == undefined ? (
          "This account hasn't posted videos in the last 7 days."
        ) : (
          <>
            <p>
              Posts of last 7 days perform{' '}
              {shortPeriodAverage > longPeriodAverage
                ? Math.trunc((shortPeriodAverage / longPeriodAverage - 1) * 100)
                : Math.trunc(
                    (1 - shortPeriodAverage / longPeriodAverage) * 100,
                  )}
              % {shortPeriodAverage > longPeriodAverage ? 'better' : 'worse'}
            </p>
            <p>
              <b>Average views of posts in last 7 days:</b>{' '}
              {Math.trunc(shortPeriodAverage).toLocaleString()}
            </p>
            <p>
              <b>Average views of posts in last 60 days:</b>{' '}
              {Math.trunc(longPeriodAverage).toLocaleString()}
            </p>
          </>
        )
      }
    >
      <div
        className={classNames(
          'mt-1.5 w-fit rounded-[100px] px-2 py-0.5 text-xs font-medium',
          {
            'bg-warning-light text-warning-dark dark:bg-[#FFB80040] dark:text-warning-default':
              state === SocialAccountPerformanceState.NORMAL_AVERAGE,
            'bg-danger-light text-danger-dark dark:bg-[#D73A4940] dark:text-[#D73A49]':
              state === SocialAccountPerformanceState.BELOW_AVERAGE,
            'bg-success-light text-success-dark dark:bg-[#28A74540] dark:text-success-default':
              state === SocialAccountPerformanceState.ABOVE_AVERAGE,
            'bg-gray-300 text-text-default dark:bg-gray-200 dark:text-black':
              state === SocialAccountPerformanceState.NA,
          },
        )}
      >
        {performanceStateText[state]}
      </div>
    </Tooltip>
  )
}
